import * as stylex from '@stylexjs/stylex';
import { appLink } from '~components/AppCta';
import { shared } from '~styles';
import { styles } from './styles';
export function Stub({
  linkId
}: {
  linkId: string;
}) {
  return <main {...stylex.props(styles.container)}>
      <h1>Tribe unavailable</h1>
      <p {...stylex.props(shared.muted)}>This tribe is private or no longer available.</p>
      <a {...stylex.props(shared.primaryButton, styles.button)} href={appLink(`triby/${linkId}`)}>
        Open in the Tribys app
      </a>
    </main>;
}